module.exports = __webpack_public_path__ + "static/media/bill_gates.95bf31a5.jpg";